import {
  createContext,
  ReactNode,
  Suspense,
  useContext,
  useEffect,
  useState,
} from "react";
import AuthContext from "mfeAuth/AuthContext";
import { MFE } from "../mock/mfe";
import Loading from "../components/Loading";
import { jwtDecode } from "jwt-decode";
import { AuthProps } from "../interfaces/AuthProps";
import { DispatchInteractUser } from "../utils/analytics/dispatchEventsAnalytics";
import { Hash } from "../utils/converters/hash";
import {
  IdentifyHasAcessModules,
  IdentifyProfileType,
} from "../utils/identifiers";

const URL_API = process.env["REACT_APP_URL_API"]
  ? process.env["REACT_APP_URL_API"]
  : "/";

const REACT_APP_ENV = process.env["REACT_APP_ENV"];

export interface DynamicModulesInterface {
  name: string;
  icon: string;
  external_link: string | null;
  active: Boolean;
  application?: {
    host: string;
    route_prefix: string;
    module_name: string;
    app_prefix: string;
    active: Boolean;
  } | null;
}

export default interface DynamicModulesProps {
  children: ReactNode;
}

export const DynamicModulesContext = createContext<
  Array<DynamicModulesInterface>
>([]);

export function DynamicModulesProvider({ children }: DynamicModulesProps) {
  const [dynamicModules, setDynamicModules] = useState<
    Array<DynamicModulesInterface>
  >([]);
  const { token } = useContext<{ token: string }>(AuthContext);
  const { extension_grupos, emails }: AuthProps = jwtDecode(token);
  const userData = extension_grupos ? JSON.parse(extension_grupos) : [];
  const modulesAcess = IdentifyHasAcessModules(userData).join("-");
  const profile = IdentifyProfileType(userData).join("-");

  if (!window?.dataLayer.find((item: any) => item.cd_perfil === profile)) {
    DispatchInteractUser(Hash(emails[0]).slice(2), modulesAcess, profile);
  }

  useEffect(() => {
    if (!REACT_APP_ENV || REACT_APP_ENV !== 'local') {
      (async () => {
        let response: any = await fetch(`${URL_API}/menu-links`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        response = await response.json();
        setDynamicModules(response);
      })();
    } else {
      setDynamicModules(MFE);
    }
  }, []);

  const AuthContextValue = dynamicModules;

  return (
    <Suspense fallback={<Loading />}>
      <DynamicModulesContext.Provider value={AuthContextValue}>
        {children}
      </DynamicModulesContext.Provider>
    </Suspense>
  );
}
